(function (upp) {
    'use strict';

    var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "loyalty";
    var URL_WEB_SOCKET_SERVER = $UPP.URL_WEB_SOCKET_CHILDUPP + "check/stamp";

    upp.service('loyaltyService', ['appi', '$q', '$window', '$rootScope', '$timeout',

        function (appi, $q, $window, $rootScope, $timeout) {

            /**
             * Returns a list of loyalty cards and its attributes
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getLoyaltiesList = (function ($q, angular) {
                var loyaltyCards,
                    _copy = angular.copy;

                return function () {
                    var deferred = $q.defer();

                    appi.http.get(URL_API_REST_SERVER + '/list')
                        .then(function (response) {
                            loyaltyCards = _copy(response.data.loyaltyCards) || null;
                            deferred.resolve(loyaltyCards);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q, angular);

            /**
             * Returns the info for the loyalty card
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getLoyaltyCard = (function ($q, angular) {
                var _copy = angular.copy;

                return function (loyaltyId) {
                    var deferred = $q.defer();

                    appi.http.get(URL_API_REST_SERVER + '/get-loyalty-card/' + loyaltyId)
                        .then(function (response) {
                            deferred.resolve(_copy(response.data));
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q, angular);

            /**
             * Returns the info for the loyalty card
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getCurrentStampsUser = (function ($q, angular) {
                var  _copy = angular.copy;

                return function (loyaltyId, userId) {
                    var deferred = $q.defer();
                    appi.http.get(URL_API_REST_SERVER + '/get-current-user-stamps/?loyaltyId=' + loyaltyId + '&userId=' + userId)
                        .then(function (response) {
                            deferred.resolve(_copy(response.data));
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q, angular);

            /**
             * Add new validation code
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _addCode = (function ($q) {
                return function (loyaltyId, userId, validationCode) {
                    var deferred = $q.defer();
                    appi.http.getSecure(URL_API_REST_SERVER + '/add-code/?loyaltyId=' + loyaltyId + '&code=' + validationCode)
                        .then(function (response) {
                            deferred.resolve(response.data.success);
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q);

            /**
             * Returns the qr image in base64 for the loyalty card
             *
             * @returns {Promise} Returns a promise that will be fulfilled or rejected
             * @private
             */
            var _getQrImage = (function ($q, angular) {
                var _copy = angular.copy;

                return function (loyaltyId) {
                    var deferred = $q.defer();

                    appi.http.getSecure(URL_API_REST_SERVER + '/qr/get?loyaltyId=' + loyaltyId)
                        .then(function (response) {
                            deferred.resolve(_copy(response.data));
                        }, function (err) {
                            deferred.reject(err);
                        });

                    return deferred.promise;
                };
            })($q, angular);


            /**
             * Check if a new stamp are added to the user
             *
             * @param {number} loyalty ID to check
             * @param {number} user ID to check
             * @returns {Promise} resolved when a new stamp are added
             * @private
             */
            var _checkStampedPoller = (function($q, $timeout) {

                return function(loyaltyId, userId, currentStamps) {

                    var deferred = $q.defer();
                    var cancel = false;

                    var data = {
                        stamps: currentStamps,
                        calls: 0,
                        maxCalls: 500 // 500 * 2 sec => ~ 15 min
                    };

                    var poller = function() {
                        if (!cancel) {
                            appi.http.getSecure(URL_API_REST_SERVER + '/get-current-user-stamps/?loyaltyId=' + loyaltyId + '&userId=' + userId).then(function(r) {
                                data.stamps = r.data.stamps;
                                data.calls++;
                                if (currentStamps === data.stamps && data.maxCalls > data.calls) {
                                    $timeout(poller, 2000);
                                } else {
                                    // if data.stamps == 0 => the gift!
                                    deferred.resolve(currentStamps+1);
                                }
                            });
                        }
                    };
                    poller();

                    return {
                        onStamp: deferred.promise.then,
                        cancel: function() {
                            cancel = true;
                        }
                    };
                }

            })($q, $timeout);

            /**
             * Check if a new stamp is fired
             *
             * @returns {Object} with a method: 'checkStamped(fnSuccess, fnError)' that will be fulfilled or rejected
             * @private
             */
            var _getConnection = (function($window, $rootScope) {

                var singleton = {
                    ws: null,
                    userId: null,
                    loyaltyId: null,
                };

                return function(userId, loyaltyId) {
                    // init websocket...
                    if (!$window.WebSocket) {
                        console.log("websocket not supported");
                    }

                    if (singleton.userId !== userId || singleton.loyaltyId !== loyaltyId) {
                        if (singleton.ws != null)
                            singleton.ws.close();

                        var ws = new $window.WebSocket(
                            URL_WEB_SOCKET_SERVER + "?userId=" + userId + "&loyaltyId=" + loyaltyId
                        );

                        ws.onopen = function (event) {
                            console.log("websocket is on");
                            console.log(event);
                        };

                        ws.onclose = function(event) {
                            console.log("websocket is off");
                            console.log(event);
                        };
                        singleton.ws = ws;
                        singleton.userId = userId;
                        singleton.loyaltyId = loyaltyId;
                    }
                    return {
                        /**
                         *
                         * @param onFnSuccess function fired if stamp check
                         * @param onFnError function fired if some errors happens
                         */
                        checkStamped: function(onFnSuccess, onFnError) {
                            console.log("init websocket!")
                            if (singleton.ws == null) {
                                if (onFnError) {
                                    onFnError();
                                    $rootScope.$apply();
                                }
                            }

                            // listen
                            singleton.ws.onmessage = function (message) {
                                onFnSuccess(message);
                                $rootScope.$apply();
                            };

                            singleton.ws.onerror = function (event) {
                                console.log('error websocket');
                                console.log(event);
                                if (onFnError) {
                                    onFnError(event);
                                    $rootScope.$apply();
                                }
                            };
                        }
                    };
                }
            })($window, $rootScope);

            return {
                getLoyaltiesList: _getLoyaltiesList,
                getLoyaltyCard: _getLoyaltyCard,
                getCurrentStampsUser: _getCurrentStampsUser,
                addCode: _addCode,
                getQrImage: _getQrImage,
                checkStamped: _checkStampedPoller,
            };
    }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/loyalty/services/loyalty-services.js